import API from '@/api'

export default {
  namespaced: true,
  state: {

    selecting_base: false,

    data: {},

    base: {},
    variety: {},
    method: {},
    goal: {},

    varieties : {},
    methods : {},
    goals : {},

    crop_list: [],

    filters: {
      take: 10,
      page: 0,
      type: 'soil-grown',
    }

  },
  mutations: {

    setData(state, data) {
      state.data = data;
    },

    saveVarieties(state, items) {
      state.varieties = items.map(n => {
        if(n.id === state.variety.id) {
          n.methods = state.variety.methods;
          state.variety = n;
        }

        return n
      });
    },

    saveMethods(state, items) {
      state.methods = items.map(n => {
        if(n.id === state.method.id) {
          n.goals = state.method.goals;
          state.method = n;
        }
        return n
      });
    },

    saveGoals(state, items) {
      state.goals = items.map(n => {
        if(n.id === state.goal.id) {
          n.stages = state.goal.stages;
          state.goal = n;
        }
        return n
      });
    },
  },
  actions: {

    getCrops({ commit, state }) {
      return API.crop.getAllCrops(state.filters).then(res => {
        commit('setData', res.data.data);
      });
    },
    getVarieties(context, id = 0) {
      return API.crop.getCropVarieties(id).then(res => {
        context.commit('saveVarieties', res.data.data);
        return res;
      });
    },
    getMethods(context, id = 0) {
      return API.crop.getCropGrowingMethods(id).then(res => {
        context.commit('saveMethods', res.data.data);
        return res;
      });
    },
    getGoals(context, id = 0) {
      return API.crop.getYieldGoals(id).then(res => {
        context.commit('saveGoals', res.data.data);
        return res;
      });
    },

  },
  getters: {

    data(state) {
      let data = state.data.map(function(el) {
        return {
          key : el.id,
          label : el.name,
          value : el.id,
        }
      } );
      return data;
    },
    varieties(state) {
      let data = state.varieties.map(function(el) {
        return {
          key : el.id,
          label : el.name,
          value : el.id,
        }
      } );
      return data;
    },
    methods(state) {
      let data = state.methods.map(function(el) {
        return {
          key : el.id,
          label : el.name,
          value : el.id,
        }
      } );
      return data;
    },
    goals(state) {
      let data = state.goals.map(function(el) {
        return {
          key : el.id,
          label : el.goal,
          value : el.id,
        }
      } );
      return data;
    },

  }
}
